/**
 * PACKING LIST STORE
 */

import api from "Api";

const state = {
    page: {},
    packing_list: null,
    packing_lists: JSON.parse(localStorage.getItem("packing_lists")) || null,
    packing_lists_filter: {
        search: "",
        company_id: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchPackingList({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitPackingList", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitPackingList", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutatePackingList", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitPackingList(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutatePackingList(state, payload) {
        if (payload.method == "post" && payload.with) {
            let property = _.get(state, payload.property);
            _.set(state, `${payload.property}[${(property || []).length}]`, payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_id = payload.id ? payload.id : payload.with[payload.pk];
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == curr_id)];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            let property = _.get(state, payload.property);
            property.splice(
                property.findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
            _.set(state, payload.property, property.length ? property : null);
        }
    },
    resetPackingLists(state) {
        // take the state values and set them back to default except for the rules_
        state.page = {};
        state.packing_list = null;
        state.packing_lists = JSON.parse(localStorage.getItem("packing_lists")) || null;
        state.packing_lists_filter = {
            search: "",
            company_id: "",
            page_size: 0,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
